"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Twitter, Instagram } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        {[...Array(5)].map((_, i) => <div key={i} data-index={i} className="h-4 w-16 bg-muted-dark/30 animate-pulse rounded" />)}
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="gap-6">
        {menuItems.slice(0, 5).map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-sm text-foreground-dark hover:text-primary transition-colors duration-[var(--duration-fast)] hover:underline underline-offset-4">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  return <footer className="bg-dark-background text-foreground-dark border-t border-muted-dark/20 animate-fade-in-up">
      <div className="container mx-auto px-6 py-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-sm text-foreground-dark/80">
            © {new Date().getFullYear()} The Mass. All rights reserved.
          </div>

          <div className="flex items-center gap-8">
            <MenuProvider menu_id="19">
              <FooterMenuConsumer />
            </MenuProvider>

            <div className="flex items-center gap-4">
              <Link to="https://facebook.com" newTab className="text-foreground-dark/80 hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="Facebook">
                <Facebook className="size-5" />
              </Link>
              <Link to="https://twitter.com" newTab className="text-foreground-dark/80 hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="Twitter">
                <Twitter className="size-5" />
              </Link>
              <Link to="https://instagram.com" newTab className="text-foreground-dark/80 hover:text-primary transition-colors duration-[var(--duration-fast)]" aria-label="Instagram">
                <Instagram className="size-5" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>;
}